import { render, staticRenderFns } from "./ShippingRateEdit.vue?vue&type=template&id=676d8c2e&scoped=true&"
import script from "./ShippingRateEdit.vue?vue&type=script&lang=js&"
export * from "./ShippingRateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRateEdit.vue?vue&type=style&index=0&id=676d8c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d8c2e",
  null
  
)

export default component.exports